import { request } from "../http";

export default {
    // 获取产品分类
    getProductTypeList(params) {
        return request('post', '/sd_smi/api/v1/Web_Product/getProductTypeList', params, 'json');
    },

    // 获取产品属性
    getProductAttrList(params) {
        return request('post', '/sd_smi/api/v1/Web_Product/getProductAttrList', params, 'json');
    },

    // 获取产品列表
    getProductList(data, current, size) {
      return request('post', '/sd_smi/api/v1/Web_Product/getProductList', data, 'json',{queryParams: {current, size}});
    },

    // 获取产品详情
    getProductDetail(params) {
        return request('post', '/sd_smi/api/v1/Web_Product/getProductDetail', params, 'json');
    },

    // 产品收藏
    productFav(params) {
        return request('post', '/sd_smi/api/v1/Web_Product/productFav', params, 'json', {checkLogin: true});
    },

    // 获取产品收藏列表
    getProductFavList(params) {
        return request('post', '/sd_smi/api/v1/Web_Product/getProductFavList', params, 'json');
    },
}



// WEBPACK FOOTER //
// ./src/request/apis/product.js